import Options from "./Options";

let loaded = false;

let raw = {};
let mode = "";
let theme = "";
let idToken = "";
let userId = "";
let name = "";
let configuration = "";
let configurationTemp = "";
let goal = "";
let shared = false;
let sessionState = "";
let promptStart = "";
let promptGoals = "";
let sessionMode = "";
let promptSubmitted = false;
let logging = "";
let sessionId = "";
let activityId = "";
let authorOptions = "";

export default class Params {

    static get raw() { return raw; }
    static get mode() { return mode; }
    static get theme() { return theme; }
    static get idToken() { return idToken; }
    static get userId() { return userId; }
    static set userId(newId) { userId = newId; }
    static get name() { return name; }
    static get configuration() { return configuration; }
    static get configurationTemp() { return configurationTemp; }
    static get goal() { return goal; }
    static get shared() { return shared; }
    static get sessionState() { return sessionState; }
    static get promptStart() { return promptStart; }
    static get promptGoals() { return promptGoals; }
    static get sessionMode() { return sessionMode; }
    static get promptSubmitted() { return promptSubmitted; }
    static get logging() { return logging; }
    static get sessionId() { return sessionId; }
    static get activityId() { return activityId; }
    static get authorOptions() { return authorOptions; }

    static set configuration(newConfiguration) {
        configuration = newConfiguration;
    }

    static load() {
        if (loaded) return;
        loaded = true;

        const querystring = require('querystring');
        const url = require('url');
        const u = url.parse(window.location.href);
        const params = querystring.decode(u.query);

        raw = params;
        mode = params.mode || "";
        theme = params.theme || "";
        idToken = params.idToken || "";
        userId = params.userId || "";
        name = params.name || "";
        configuration = params.configuration || "";
        configurationTemp = params.configurationTemp || "";
        goal = params.goal || "";
        shared = params.shared == "true";
        sessionState = params.sessionState || "";
        promptStart = params.promptStart || "";
        promptGoals = params.promptGoals || "";
        sessionMode = params.sessionMode || "";
        promptSubmitted = params.promptSubmitted == "true";
        logging = params.logging || "";
        sessionId = params.sessionId || "";
        activityId = params.activityId || "";
        authorOptions = params.authorOptions || "";

        document.body.classList.add(`theme-${theme}`);

        Options.setCurrent(params);
    }
}